import React from 'react';
import professorPhoto from '../assets/images/professor-stephen.jpg';
import '../styles/AboutPage.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-content">
        <div className="profile-section">
          <img 
            src={professorPhoto} 
            alt="Professor Stephen Njenga" 
            className="profile-image"
          />
          <div className="badge">Notary Public</div>
        </div>
        
        <div className="bio-section">
          <h1>About Professor Stephen Njenga</h1>
          <p>
            With over 15 years of experience as a commissioned Notary Public, 
            Professor Njenga provides professional notarization services to 
            individuals and businesses throughout Federal Way, WA.
          </p>
          <h2>Credentials</h2>
          <ul>
            <li>Commissioned Notary Public - State of Washington</li>
            <li>Certified Remote Online Notary</li>
            <li>Member, National Notary Association</li>
          </ul>
          <div className="cta-section">
            <a href="tel:2065664676" className="cta-button">
              Schedule Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;